import eventName from "./store/schema/eventName";
import EventEmitter from "owa-event-emitter";
import getStore from "./store/store";

export default function getNotificationEmitter(key: string, windowRef: Window | null = null): EventEmitter {
    const eStore = getStore();
    if (!eStore.emitters[key]) {
        const emitter = new EventEmitter();
        eStore.emitters[key] = emitter;
        (windowRef || window).addEventListener("resize", () => {
            eStore.emitters[key].emit(eventName);
        });
    }
    
    return eStore.emitters[key];
}
